import { apiConnections } from '@pkg/env';

import { type MakeUrl } from '../../structs';

// Take a settings bag and turn it into a valid API URL endpoint.
export function makeUrl({ settings, websocket = false, apiSettingsType = 'yat' }: MakeUrl): string {
    let secure = false;
    const apiConnection = apiConnections[apiSettingsType];
    const { url, proxyPath } = apiConnection;
    const proxy = proxyPath;

    if (settings && settings.useSecure) {
        secure = true;
    }

    if (proxyPath) return proxyPath.startsWith('/') ? proxyPath : `/${proxyPath}`;
    if (url && url.indexOf('://') > -1) return url;

    const prefix = websocket ? `ws${secure ? 's' : ''}://` : `http${secure ? 's' : ''}://`;

    if (url) return `${prefix}${proxy}${url}`;

    // Shallow clone to fix issues with empty values
    const env = Object.assign({}, process.env);
    const defaultUrl = env.REACT_APP_API_DOMAIN || 'a.y.at';

    return `${prefix}${defaultUrl}`;
}
